/**
 * Компонент формы
 * @module b-form
 */

/**
 * Сериализованное значение поля ввода
 * @typedef {Object} SerializedInput
 * @property {string} name - имя поля
 * @property {string} value - значение
 */

define('mrg-form/b-form/b-form', function(require) {
	'use strict';

	require('mrg-form/b-form-field/b-form-field');
	require('mrg-form/b-form-row/b-form-row');

	var	$ = require('jquery'),
		toolkit = require('toolkit/b-toolkit/b-toolkit'),
		validators = require('mrg-form/b-form/b-form.validators');

	require('toolkit/btn/btn');

	var focusTimeout;

	var BForm = toolkit.create( 'b-form', /** @lends b-form# */ {

		scrollToErrorField: true,

		init: function () {
			this._initForm();

			var data = this.getData();

			if (data.currentErrors) {
				this.showErrors(data.currentErrors);
			}

			if (data.commonError) {
				this.toggleFormError(data.commonError, true);
			}

			if (data.disabled) {
				this.toggleMod('disabled', true);
			}
		},

		/**
		 * Подписка на события филда
		 *
		 * @param field
		 * @private
		 */
		_onFieldsEvents: function(field) {
			// когда изменлось состояние о ошибках
			field.on('updateErrors blurFormField changeFormValue', function(event) {
				this.emit(event.type);
			}.bind(this));

			// поле сообщает что нужно провалидировать его немедленно
			field.on('needValidate', function(field) {
				this._validateField(field, field.blurValidators);
			}.bind(this, field));
		},

		onRender: function () {
			this._initForm();
		},

		_initForm: function () {
			this.$el
				.off('submit')
				.on('submit', this.onFormSubmit.bind(this));

			this.$form = this.$('form').length !== 0 ? this.$('form') : this.$el;
			this.$form.attr('novalidate', 'novalidate');

			var fields = this.getFields();

			fields.forEach(function setGetterFormData(item){
				item.setGetterFormData(this.getFormData.bind(this));

				this._onFieldsEvents(item);
			}.bind(this));

			// если произойдет инициализация филда независимо от формы,
			// то нужно подписаться на это событие чтобы снова подписаться на события
			// при обычной инициализации не произойдет двойной подписки т.к. инитятся филды,
			// а потом мы попадаем только сюда и подписываемся на это событие
			this.$form.on('bFormFieldInitEnd', function(event, field){
				event.stopPropagation();
				this._onFieldsEvents(field);
			}.bind(this));

			this._initFocus();
		},

		/**
		 * Валидируем одно поле
		 *
		 * @param field
		 * @param {array} needValidators на какие валиаторы нужно валидировать,
		 * 	если ничего не указано валидируем на все
		 * @private
		 */
		_validateField: function(field, needValidators) {
			var rowName = field.name;
			var error;
			var errors = {};

			field.hideErrors();

			for (var validator in validators) {

				if (needValidators) {
					if (!needValidators.includes(validator)) {
						continue;
					}
				}

				error = field.validate(validators[validator].bind(field));
				if (error) {
					errors[rowName] = typeof error === 'boolean' ?
						validator :
						error;

					break;
				}
			}

			this.showErrors(errors);
		},

		/**
		 * Метод который будет вызван при сабмите формы
		 * @param {Event} e - событие сабмита
		 */
		onFormSubmit: function (e) {

			$.event.trigger('ui-abstract-action', {chain: ['form', 'try-submit']});

			// проверяем на наличие полей в статусе processing
			// если такие есть, то не выполняем submit
			if (this.isProcessing()) {
				e.preventDefault();
				return;
			}

			var data = this.getData();
			var errors = {};

			if (!this.validate(null, null, errors)) {
				e.preventDefault();
				$.event.trigger('ui-abstract-action', {chain: ['form', 'errors']});
				this.focusErrorField();
				this.onErrors(errors);
				return;
			}

			if (!data.nativesubmit) {
				e.preventDefault();

				$.event.trigger('ui-abstract-action', {chain: ['form', 'submit']});

				this.emit('submit', this.getFormData());
				this.onPost(this.getFormData());
			}

		},

		/**
		 * Инициализирует фокус
		 *
		 */
		_initFocus: function() {
			var data = this.getData();

			var notHiddenFields = this.getFields().filter(function (field) {
				return !field.hidden;
			});

			var indexFocus = 0;

			if(data.autofocusName !== undefined) {
				notHiddenFields.forEach(function (el, i) {
					if (el.data.name === data.autofocusName) {
						indexFocus = i;
					}
				});
			}

			if (notHiddenFields.length && !data.notFirstFocus) {
				if (focusTimeout) {
					clearTimeout(focusTimeout);
				}
				focusTimeout = setTimeout(function () {
					if (this._isSupportFirstFocus()) {
						notHiddenFields[indexFocus].focus();
					}
				}.bind(this),100);
			}
		},

		/**
		 * Устанавливает фокус на первом элементе с ошибкой
		 *
		 * @private
		 */
		focusErrorField: function () {
			$.event.trigger('ui-abstract-action', {
				chain: ['form', 'try', 'focus', 'err-field']
			});
			var field = this.getFields('invalid')[0];

			if(!field) {
				return;
			}

			$.event.trigger('ui-abstract-action', {
				chain: ['form', 'focus', 'err-field']
			});

			field.focus();

			if (this.scrollToErrorField) {
				$('html, body').animate({
					scrollTop: field.$el.offset().top
				}, 0);
			}
		},

		/**
		 * Метод будет вызван после сабмита, и после успешной валидации формы
		 * @param {object} data - данные формы
		 */
		onPost: function (data) {},

		/**
		 * Метод будет вызван после сабмита, если форма не валидная
		 * @param {object} errors - данные об ошибках формы
		 */
		onErrors: function (errors) {},

		/**
		 * Метод выполняет десереализицию данных,
		 * которые приходят в поле echo_params при 449 ответах
		 * данные получатся только если это объект или JSON
		 *
		 * @param {*} data
		 * @returns {Object}
		 * */
		getEchoParams: function (data) {
			var result = {};
			if (!data) {
				return result;
			}

			if (typeof data === 'object') {
				Object.keys(data).forEach(function (key) {
					result[key] = this.getEchoParams(data[key]);
				}, this);
			}

			if (typeof data === 'string') {
				try {
					result = JSON.parse(data);
				} catch (_) {
					result = data;
				}
			}

			return result;
		},

		/**
		 * Проверяет есть ли поля в статусе
		 *
		 */
		isProcessing: function() {
			var result = false;
			this.getFields().forEach(function(item) {
				if (result) return;

				if (item.isProcessing()) {
					result = true;
				}
			});

			return result;
		},

		/**
		 * Валидация входных данных
		 * Поля с модификатор not-validated не валидируются
		 *
		 * @param {object|null} data - данные, нужны для рекурсивного обхода
		 * @param {options|null} options - специфичные правила обхода
		 * @param {*} _errors - объект для хранения ошибок
		 *
		 * @returns {boolean}
		 * 	false - если форма содержит не валидные поля
		 * 	true - если форма валидна
		 */
		validate: function (data, options, _errors) {
			data = data || this.getFormData(options);

			var errors = _errors || {},
				findValidateErr = false,
				findOwnErr = false;

			this.hideErrors();
			this._validateProcess(data, '', errors);

			// проверяем есть ли у field-ов свои собственные ошибки
			this.getFields().forEach(function(field){
				if(findOwnErr === true) return;
				if(field.hasOwnError()) findOwnErr = true;
			});

			if (!$.isEmptyObject(errors)) {
				this.showErrors(errors);
				findValidateErr = true;
			}

			if(findOwnErr || findValidateErr) {
				return false;
			} else {
				return true;
			}
		},

		/**
		 * Метод возвращает дом элемент, для поиска используется его имя
		 * @param {string} name - имя искомого поля
		 * @return {JQuery.Node} - искомое поле
		 */
		getField: function (name) {
			var result = null;

			this.getFields().forEach(function (field) {
				if(result) return;
				if(field.name === name) {
					result = field;
				}
			});

			return result;
		},

		/**
		 * Метод получает список филдов формы
		 *
		 * @param mod модификатор, если есть
		 *      то возвращаются только блоки с данным модификатором
		 * @return {Array#Block} - список блоков
		 */
		getFields: function (mod) {
			return this.$form.findBem('b-form-field').toArray().map(function (el) {
				return $(el).getBlock();
			}).filter(function (field) {
				if(mod && field.hasMod(mod) || !mod) {
					return !!field;
				}
			});
		},

		/**
		 * Получаем список контролов в форме, блоки сразу
		 *
		 * @param mod
		 */
		_getControls: function(mod) {
			return this.$('.b-form__controls .b-form__control')
				.toArray().map(function (el) {
					return $(el).find('[data-bem]').getBlock();
				})
				.filter(function (field) {
					if(mod && field.hasMod(mod) || !mod) {
						return !!field;
					}
				});
		},

		_validateProcess: function (data, root, errors) {
			var name,
				validator,
				key,
				field;

			for (key in data) {
				name = root || key;
				field = this.getField(root ? root + '__' + key : key);

				if (
					typeof data[key] === 'object' &&
					!(field && field.input && field.input.multiple)
				) {
					this._validateProcess(data[key], key, errors);
					continue;
				}

				if (!field) {
					continue;
				}

				if (field.notValidated) {
					continue;
				}

				var rowName = field.name || key,
					error;

				for (validator in validators) {
					error = field.validate(validators[validator].bind(field));
					if (error) {

						errors[root] = errors[rowName] = typeof error === 'boolean' ?
							validator :
							error;

						break;
					}
				}

			}
		},

		/**
		 * Метод сериализует данные из дом элементов в массив
		 * @memberOf b-form#
		 * @private
		 * @return {SerializedInput[]} - массив с сериализованными данными
		 */
		_serialize: function () {
			//TODO вынести всю эту логику в блок b-form-row
			// а тут работать только с b-form-row

			var result = this.getFields().map(function (field) {
				return { value: field.getValue(), name: field.name };
			});

			// собираем все инпуты и их значения вне филдов
			var $inputs = this.$el.find(
				['input', 'textarea'].map(function(tagName) {
					return '.b-form-row > div:not(.b-form-field) ' + tagName;
				}).join(',')
			);
			result = $inputs.toArray().map(function(item){
				return {
					name: item.name,
					value: item.value
				};
			}).concat(result);

			return result;
		},

		/**
		 * @desc Метод получения объекта данных из формы.
		 * Умеет работать строить вложенные объекты
		 *
		 * Например такое если форма будет содержать
		 * поля со следующими именами:
		 * 		- fio__firstname
		 * 		- fio__lastname
		 * 		- salary
		 * То в ответ будет отдан следующий объект
		 * 	{
		 * 		fio: {
		 * 			fisrtname: "",
		 * 			lastname: ""
		 * 		},
		 *   	salary: "
		 * 	}
		 *
		 * @param {Object} options - параметры сбора данных с формы
		 * @param {Boolean} options.removeQuotes -
		 *     удаляем двойные кавычеки (mail-39203)
		 *
		 * @returns {Object} - объект с данными из полей формы
		 */
		getFormData: function (options) {
			var values = this._serialize(),
				nested = /(.*)__(.*)/i,
				result = {};

			options = options || {};

			function prepare(str, name) {

				if (typeof str !== 'string') {
					return str;
				}

				if (!options.keepSpaces) {
					str = str.trim();
				}

				if (name === 'echo_params') {
					return str;
				}

				if (options.removeQuotes) {
					return str.replace(/\"/ig, '');
				}

				return str;
			}

			values.forEach(function (val) {
				var key = val.name;

				if (nested.test(val.name)) {
					key = val.name.replace(nested, '$1');
					result[key] = result[key] || {};
					result[key][val.name.replace(nested, '$2')] =
						prepare(val.value, val.name);
				} else {
					result[val.name] = prepare(val.value, val.name);
				}

			}.bind(this));

			/**
			 * Данный поле используется при 449 ответах от апи
			 * TODO Вынести в отдельный блок b-echo-params
			 */
			if(result.echo_params) { // jshint ignore:line
				// важно добавлять result в последнюю очередь,
				// чтобы он перезаписал свойства добавленные ранее
				result = $.extend({}, this.getEchoParams(result.echo_params), result); // jshint ignore:line
				delete result.echo_params; // jshint ignore:line
			}

			return result;
		},

		/**
		 * Возвращает типы ошибок для каждого поля (текущее состояние по ошибкам)
		 *
		 */
		getErrors: function() {
			var result = {};

			this.getFields().forEach(function (field) {
				if (!field.name) {
					// TODO такого не должно по идее быть, нужно добавить запись в лог
				}

				result[field.name] = field.error;
			});

			return result;
		},

		/**
		 * Возвращает текущий тип общей ошибки
		 *
		 */
		getCommonError: function() {
			return this.commonError;
		},

		/**
		 * Метод показывает ошибки
		 * @param errors
		 */
		showErrors: function (errors) {
			var type,
				field,
				text,
				key;

			for (key in errors) {
				if (typeof errors[key] === 'object' && errors[key] !== null) {
					type = errors[key].error;
					text = errors[key].text;
				} else {
					type = errors[key];
				}

				// если формат name - name[2] такой, то предполагается что элемент
				// возвращает массив значений, а текущее относится ко второму
				// элементу внтури этого филда
				var match = /(.+)\[(\d+)\]/.exec(key);
				if (match) {
					field = this.getField(match[1]);
					if(field){
						field.showError(type, parseInt(match[2]), text);
					}
				} else {
					field = this.getField(key);
					if(field){
						field.showError(type, text);
					}
				}
			}

			this.emit('updateErrors');

		},

		/**
		 * Скрывает определеную ошибку если она есть
		 *
		 * @param {string} fieldName
		 * @param {string} error
		 * @returns {BForm}
		 */
		hideError: function(fieldName, error) {
			var findField;

			this.getFields().forEach(function (field) {
				if (findField) return;

				if (field.name === fieldName) {
					findField = field;
				}
			});

			if (findField) {
				if (findField.error === error) {
					findField.hideErrors();
				}
			}

			return this;
		},

		/**
		 * Метод скрывает все ошибки формы
		 *
		 * @param {boolean} force если true то скрываем любые ошибки -
		 *      даже если они этого не хотят
		 */
		hideErrors: function (force) {
			this.getFields().forEach(function (field) {
				field.hideErrors(force);
			});

			this.emit('updateErrors');
		},

		/**
		 * Устанавливает значение полей формы
		 * @param {Object} fields - объект с полями формы
		 */
		setFormData: function (fields) {
			Object.keys(fields).forEach(function (fieldName) {
				var field = this.getField(fieldName);
				if(field) {
					field.setValue(fields[fieldName]);
				}
			}.bind(this));
		},

		destroy: function () {
			this.$el.unbind('.b-form__row__widget', 'change keyup');
			this.$el.unbind('submit');

			toolkit['b-toolkit'].fn.destroy.apply(this, arguments);
		},

		/**
		 * Передаем модификаторы дальше дочерним блокам
		 *
		 * @param mod
		 * @param state
		 */
		toggleMod: function(mod, state) {
			toolkit['b-toolkit'].fn.toggleMod.call(this, mod, state);

			//TODO нужно проходить по всем b-form-row а там уже передавать во филды

			this.getFields().forEach(function (field) {
				field.toggleMod(mod, state);
			});

			this._getControls().forEach(function (field) {
				field.toggleMod(mod, state);
			});
		},

		/**
		 * Метод показывает или скрывает ошибки формы
		 * @param {string} [error] - имя ошибки, если не передан то применяется
		 * 		ко всем полям
		 * @param {boolean} state - показать или скрыть ошибку
		 * @param {string} text – кастомный текст ошибки, если необходимо
		 */
		toggleFormError: function(error, state, text) {
			var errorText,
				errorEl;

			// может показана быть только одна ошибка - поэтому всегда скрываем всё до того как что-то покажем
			this.$('.b-form__errors__error').toggleMod('visible', false);

			if (typeof error === 'boolean') {
				this.$('__errors .js-error').toggleMod('visible', error);
			} else {
				errorEl = this.$('__errors .js-' + error);
				errorEl.toggleMod('visible', state);

				if (error && state) {
					$.event.trigger('ui-abstract-action', {
						chain: ['form', 'commonerr', error]
					});

					if (typeof text !== 'undefined') {
						errorEl.text(text);
					} else {
						errorEl.html(errorEl.data('text'));
					}

					this.commonError = error;
				} else {
					$.event.trigger('ui-abstract-action', {
						chain: ['form', 'commonerr', 'valid']
					});
					this.commonError = null;
				}
			}

			// если есть модификатор то прокручиваем скрол до этого элемента,
			if (this.hasMod('scroll-to-error') && error) {
				var elem = this.$('__errors')[0];
				if (elem) {
					elem.scrollIntoView(false);
				}
			}

			this.emit('updateErrors');
		},

		/**
		 * Не все девайсы поддерживают фокус на первом элементе,
		 * например не поддерживает мобильный сафари в айфонах
		 * @private
		 */
		_isSupportFirstFocus: function() {
			var result = true;

			// отсеиваем айфоны и айпады с их сафари
			if(
				/AppleWebKit.+Mobile.+Safari/i.test(navigator.userAgent) &&
				!/CriOS/i.test(navigator.userAgent)
			) {
				result = false;
			}

			return result;
		}

	});

	/**
	 * Метод регистрирует новый тип валидатора
	 * @param {Object} name
	 * @param {Object} fn
	 */
	BForm.registerValidator = function (name, fn) {
		validators[name] = fn;
	};

	return BForm;
});
